import type { HttpPort, IOmniSearchService, OmniSearchHit } from "../contracts";

// OmniSearchService — wrapper over foundation.presentation GET /api/web/omni-search
// (PC-10). Cross-model record search over models that opted in via
// @api.model(omni_search=True). The command palette's record-search source is
// the primary consumer; the AbortSignal lets it cancel a superseded keystroke.
export class OmniSearchService implements IOmniSearchService {
    constructor(private readonly http: HttpPort) {}

    async search(
        query: string,
        opts?: { limit?: number; signal?: AbortSignal },
    ): Promise<OmniSearchHit[]> {
        const q = (query ?? "").trim();
        if (!q) return [];
        const params = new URLSearchParams({ q });
        if (opts?.limit != null) params.set("limit", String(opts.limit));
        const res = await this.http.get<{ hits?: OmniSearchHit[] }>(
            `/api/web/omni-search?${params.toString()}`,
            { signal: opts?.signal },
        );
        return res.hits ?? [];
    }
}
